<!-- @author zhengjie -->
<template>
  <div class="icon-body">
    <el-input v-model="name" style="position: relative;" clearable placeholder="请输入图标名称" @clear="filterIcons" @input.native="filterIcons">
      <i slot="suffix" class="el-icon-search el-input__icon" />
    </el-input>
    <div class="icon-list">
      <div v-for="(item, index) in iconList" :key="index" @click="selectedIcon(item)">
        <!-- <svg-icon :icon-class="item" style="height: 30px;width: 16px;" /> -->
        <i :class="item"></i>
        <!-- <span>{{ item }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { elementIcons } from '@/icons/icon'
import icons from './requireIcons'
export default {
  name: 'IconSelect',
  data() {
    return {
      name: '',
      iconList: elementIcons
    }
  },
  created() {
  },
  methods: {
    filterIcons() {
      this.iconList = elementIcons
      if (this.name) {
        this.iconList = this.iconList.filter(item => item.includes(this.name))
      }
    },
    selectedIcon(name) {
      this.$emit('selected', name)
      document.body.click()
    },
    reset() {
      this.name = ''
      this.iconList = elementIcons
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.icon-body {
  width: 100%;
  padding: 10px;
  .icon-list {
    height: 200px;
    overflow-y: scroll;
    margin-top: 20px;
    div {
      margin-bottom: 15px;
      cursor: pointer;
      width: 10%;
      float: left;
      // color:#1596cd;
    }
    i{
      font-size: 22px;
    }
    span {
      display: inline-block;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
    }
  }
}
</style>
